<!--<div style="height: 5%; width: 97%; margin: auto; background: white; display:flex; flex-direction:row; justify-content:flex-end;align-items:center">
  <div>
    <button class="refresh-btn" (click)="refreshComponent()">
      <span class="bi bi-arrow-clockwise"></span>
      Refresh
    </button>
  </div>
</div>-->
<div class="main-body position-relative container-div">
  <div *ngFor="let dep of clientSessions; let i = index">
    <mat-expansion-panel
      *ngFor="let nodeGroup of dep.nodeGroups; let i = index"
      expanded
      style="margin-bottom: 40px; box-shadow: none !important"
    >
      <mat-expansion-panel-header
        class="border-bottom"
        style="border-radius: 0px"
      >
        <mat-panel-title>
          <h3 style="margin: 0">
            {{ dep.referenceDeploymentName }} : {{ nodeGroup.name }}
          </h3>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div style="display: flex; flex-wrap: wrap">
        <div
          *ngIf="nodeGroup.hasWindow"
          style="
            display: flex;
            flex-direction: column;
            max-width: 100px;
            align-items: center;
            margin: 20px;
            padding: 10px;
          "
        >
          <span
            class="deployment-image"
            style="position: relative; display: inline-block"
          >
            <img
              src="../../../../assets/images/client/windows_icon.png"
              (dblclick)="
                getSessionFromDeployment(
                  dep.deploymentName,
                  nodeGroup.name,
                  'windows'
                )
              "
              width="50px"
              height="50px"
              style="background-color: white; padding: 5px"
            />
            <ngx-spinner
              bdColor="rgba(0,0,0,0)"
              size="small"
              color="var(--s-primary-color)"
              type="ball-spin"
              [fullScreen]="false"
              [name]="nodeGroup.name + '-windows'"
              style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                pointer-events: none;
              "
            >
            </ngx-spinner>
          </span>
          <div style="padding: 5px; max-width: inherit">
            <p style="width: 100%; margin: 0px; overflow-wrap: break-word">
              Desktop
            </p>
          </div>
        </div>
        <div
          *ngIf="nodeGroup.hasLinux"
          style="
            display: flex;
            flex-direction: column;
            max-width: 100px;
            align-items: center;
            margin: 20px;
            padding: 10px;
          "
        >
          <span
            class="deployment-image"
            style="position: relative; display: inline-block"
          >
            <img
              src="../../../../assets/images/client/linux_icon.png"
              (dblclick)="
                getSessionFromDeployment(
                  dep.deploymentName,
                  nodeGroup.name,
                  'linux'
                )
              "
              width="50px"
              height="50px"
              style="background-color: white; padding: 5px"
            />
            <ngx-spinner
              bdColor="rgba(0,0,0,0)"
              size="small"
              color="var(--s-primary-color)"
              type="ball-spin"
              [fullScreen]="false"
              [name]="nodeGroup.name + '-linux'"
              style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                pointer-events: none;
              "
            >
            </ngx-spinner>
          </span>
          <div style="padding: 5px; max-width: inherit">
            <p style="width: 100%; margin: 0px; overflow-wrap: break-word">
              Desktop
            </p>
          </div>
        </div>
      </div>
      <div
        *ngIf="false"
        class="d-flex justify-content-center align-items-center"
        style="height: 200px"
      >
        <p style="margin: 0; font-size: 12px">No Synchpc Service Available</p>
      </div>
    </mat-expansion-panel>
  </div>
</div>
<ng-template #clientSessionHTML>
  <div
    class="tooltipNodeName tooltip-content"
    style="text-align: left"
    [innerHTML]="clientSessionTooltipHtml | safeHtml"
  ></div>
</ng-template>
